const e=new WeakMap;export{e as visualElementStore};
